import type { TaskStatusKey } from '../../../api/scraping';

export enum ScrapingStatus {
  SUBMITTED = 'SUBMITTED',
  PENDING = 'PENDING',
  IN_PROCESS = 'IN_PROCESS',
  IN_PROCESS_PARSING = 'IN_PROCESS_PARSING',
  IN_PROCESS_KNOWLEDGE = 'IN_PROCESS_KNOWLEDGE',
  IN_PROCESS_DEMO = 'IN_PROCESS_DEMO',
  SUCCESS = 'SUCCESS',
  SUCCESS_PARSING = 'SUCCESS_PARSING',
  SUCCESS_KNOWLEDGE = 'SUCCESS_KNOWLEDGE',
  SUCCESS_DEMO = 'SUCCESS_DEMO',
  FAILURE = 'FAILURE',
  FAILURE_PARSING = 'FAILURE_PARSING',
  FAILURE_KNOWLEDGE = 'FAILURE_KNOWLEDGE',
  FAILURE_DEMO = 'FAILURE_DEMO',
  REVOKED = 'REVOKED',
  RETRY = 'RETRY',
  STARTED = 'STARTED',
  UNKNOWN = 'UNKNOWN',
}

export enum OutputMode {
  FLAT_FILE = 'FLAT_FILE',
  ARCHIVE = 'ARCHIVE',
}

export enum ScrapingDepthType {
  ONE_PAGE = 'ONE_PAGE',
  ALL_PAGES = 'ALL_PAGES',
}

export const outputModeOptions: Array<OptionType> = [
  { label: 'Flat File', value: OutputMode.FLAT_FILE },
  { label: 'Archive', value: OutputMode.ARCHIVE },
];

export const depthTypeOptions: Array<OptionType> = [
  { label: 'One page only', value: ScrapingDepthType.ONE_PAGE },
  { label: 'All pages on the site', value: ScrapingDepthType.ALL_PAGES },
];

export const sliderStepOptions = ['0', '1', '2', '3', '4', '5', '∞'];

export const pageLimitStepOptions = [
  '1',
  '500',
  '1000',
  '2500',
  '5000',
  '10000',
];

export const filterStatusOptions: Array<
  OptionType<TaskStatusKey | 'IN_PROCESS' | ''>
> = [
  { value: '', label: 'All' },
  { value: 'SUCCESS', label: 'Success' },
  { value: 'RETRY', label: 'Retry' },
  { value: 'IN_PROCESS', label: 'In progress' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'FAILURE', label: 'Failed' },
];

export const ACTION_LABELS = {
  INFO: 'Info',
  DOWNLOAD: 'Download',
  RETRY: 'Retry',
  VIEW_ERRORS: 'View Errors',
  DELETE: 'Delete',
  REFRESH_DEMO: 'Refresh Demo',
  UPLOAD_SCREENSHOT: 'Upload Screenshot',
} as const;

export const ACTION_TYPES = {
  INFO: 'info',
  DOWNLOAD: 'download',
  RETRY: 'retry',
  VIEW_ERRORS: 'view_errors',
  DELETE: 'delete',
} as const;
